(function($) {

  var windowWidth;
  var intro, videoContainer, iframe, player;

  function enableMatchHeight(){
    $(".award > .row").matchHeight({byRow: false});
    $("#introduction .video .bgimage").matchHeight({byRow: false, target:$("#introduction .welcome")});
    $("figcaption").matchHeight({byRow:true})
  }

  function disableMatchHeight(){
    $(".award > .row").matchHeight({remove: true}).height("auto");
  }

  function onResize(){
    if(isSmallScreen()){
      disableMatchHeight();
    } else {
      enableMatchHeight();
    }
  }

  function isSmallScreen(){
    windowWidth = $(window).width();
    return windowWidth <= 544 ? true : false
  }

  function playVideo(){
   
    showVideo();

    player.play();
    return false;
  }

  function showVideo(){
    intro.addClass('hidden-xs-up');
    videoContainer.addClass("animated fadeIn");
    videoContainer.removeClass('hidden-xs-up');
  }

  function hideVideo(){
    intro.addClass("animated fadeIn")
    intro.removeClass('hidden-xs-up');
    videoContainer.addClass('hidden-xs-up');
  }

  function initVideo(){
    intro = $("#intro");
    videoContainer = $("#home-video-container");
    iframe = $("iframe", videoContainer).get(0);
    if(iframe){
      player = new Vimeo.Player(iframe);
      player.on("pause", hideVideo);
      $(".play-arrow > a").on("click", playVideo)
    }
  }

  function init(){
    $(window).on("resize", onResize);
    initVideo();
    onResize();
  }

  $(document).ready(init);

})(jQuery);
